{
  "$extensions": {
    "com.figma.modeName": "Light"
  },
  "Background": {
    "Page": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9803921568627451,
          0.9803921568627451,
          0.9803921568627451
        ],
        "alpha": 1,
        "hex": "#FAFAFA"
      }
    },
    "Subtle": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8235294117647058,
          0.8274509803921568,
          0.8470588235294118
        ],
        "alpha": 1,
        "hex": "#D2D3D8"
      }
    },
    "Raised": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.21176470588235294,
          0.2196078431372549,
          0.24705882352941178
        ],
        "alpha": 1,
        "hex": "#36383F"
      }
    }
  },
  "Text": {
    "Primary": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.07058823529411765,
          0.07058823529411765,
          0.07058823529411765
        ],
        "alpha": 1,
        "hex": "#121212"
      }
    },
    "Secondary": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.23529411764705882,
          0.24313725490196078,
          0.27450980392156865
        ],
        "alpha": 1,
        "hex": "#3C3E46"
      }
    },
    "Disabled": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.4,
          0.40784313725490196,
          0.4549019607843137
        ],
        "alpha": 1,
        "hex": "#666874"
      }
    }
  },
  "State": {
    "Selected": {
      "Container": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.7764705882352941,
            0.8196078431372549,
            1
          ],
          "alpha": 1,
          "hex": "#C6D1FF"
        }
      }
    },
    "Disabled": {
      "Container": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.7019607843137254,
            0.7058823529411765,
            0.7411764705882353
          ],
          "alpha": 1,
          "hex": "#B3B4BD"
        }
      }
    },
    "Error": {
      "Container": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            1,
            0.7450980392156863,
            0.8196078431372549
          ],
          "alpha": 1,
          "hex": "#FFBED1"
        }
      },
      "Border": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.5843137254901961,
            0,
            0.2901960784313726
          ],
          "alpha": 1,
          "hex": "#95004A"
        }
      },
      "Text": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.34901960784313724,
            0,
            0.1568627450980392
          ],
          "alpha": 1,
          "hex": "#590028"
        }
      }
    }
  },
  "Border": {
    "Subtle": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.7019607843137254,
          0.7058823529411765,
          0.7411764705882353
        ],
        "alpha": 1,
        "hex": "#B3B4BD"
      }
    },
    "Default": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.49019607843137253,
          0.5019607843137255,
          0.5450980392156862
        ],
        "alpha": 1,
        "hex": "#7D808B"
      }
    },
    "Strong": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.4,
          0.40784313725490196,
          0.4549019607843137
        ],
        "alpha": 1,
        "hex": "#666874"
      }
    }
  },
  "Action": {
    "Primary": {
      "Subtle": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.7764705882352941,
            0.8196078431372549,
            1
          ],
          "alpha": 1,
          "hex": "#C6D1FF"
        }
      },
      "SubtleHover": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.6235294117647059,
            0.6823529411764706,
            1
          ],
          "alpha": 1,
          "hex": "#9FAEFF"
        }
      },
      "Border": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.4,
            0.4117647058823529,
            0.984313725490196
          ],
          "alpha": 1,
          "hex": "#6669FB"
        }
      },
      "Default": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.2549019607843137,
            0.1803921568627451,
            0.7607843137254902
          ],
          "alpha": 1,
          "hex": "#412EC2"
        }
      },
      "Hover": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.20392156862745098,
            0.07058823529411765,
            0.6470588235294118
          ],
          "alpha": 1,
          "hex": "#3412A5"
        }
      },
      "Pressed": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.1568627450980392,
            0,
            0.5176470588235295
          ],
          "alpha": 1,
          "hex": "#280084"
        }
      },
      "Text": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.10588235294117647,
            0,
            0.37254901960784315
          ],
          "alpha": 1,
          "hex": "#1B005F"
        }
      }
    },
    "Secondary": {
      "Subtle": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.9490196078431372,
            0.8196078431372549,
            0.38823529411764707
          ],
          "alpha": 1,
          "hex": "#F2D163"
        }
      },
      "SubtleHover": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.8392156862745098,
            0.6941176470588235,
            0
          ],
          "alpha": 1,
          "hex": "#D6B100"
        }
      },
      "Border": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.5882352941176471,
            0.4980392156862745,
            0
          ],
          "alpha": 1,
          "hex": "#967F00"
        }
      },
      "Default": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.36470588235294116,
            0.3176470588235294,
            0
          ],
          "alpha": 1,
          "hex": "#5D5100"
        }
      },
      "Hover": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.2823529411764706,
            0.24313725490196078,
            0
          ],
          "alpha": 1,
          "hex": "#483E00"
        }
      },
      "Pressed": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.20784313725490197,
            0.1803921568627451,
            0
          ],
          "alpha": 1,
          "hex": "#352E00"
        }
      },
      "Text": {
        "$type": "color",
        "$value": {
          "colorSpace": "srgb",
          "components": [
            0.1411764705882353,
            0.12549019607843137,
            0
          ],
          "alpha": 1,
          "hex": "#242000"
        }
      }
    }
  }
}
